import {
  DeserializedRecord,
  deserializeItem,
  deserializeManyRelationship,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIManyRelationship,
  JSONAPIRecord,
  JSONAPISingleRelationship
} from "../../../Helpers";
import {deserializeSectionSurvey, SectionSurvey} from "./section/Survey";
import {Component, deserializeProgramComponent} from "../../Component";
import {deserializeSectionMedium, SectionMedium} from "./section/Medium";

interface Section extends DeserializedRecord {
  name: string;
  description?: string;
  position: number
  sectionSurveys: SectionSurvey[],
  sectionMedia: SectionMedium[]
  programComponent: Component
}

interface SectionData extends JSONAPIRecord {
  relationships: {
    section_surveys: JSONAPIManyRelationship,
    section_media: JSONAPIManyRelationship,
    program_component: JSONAPISingleRelationship
  }
}

const deserializeSection: Deserializer<Section, SectionData> = (data, included) => {
  const sectionSurveys = deserializeManyRelationship<SectionSurvey>(data.relationships.section_surveys, included, deserializeSectionSurvey);
  const sectionMedia = deserializeManyRelationship<SectionMedium>(data.relationships.section_media, included, deserializeSectionMedium);
  const programComponent = deserializeSingleRelationship<Component>(data.relationships.program_component, included, deserializeProgramComponent);

  return {
    sectionSurveys,
    sectionMedia,
    programComponent,
    ...deserializeItem(data)
  };
};


export {
  Section, deserializeSection
};
